'use strict';

//Model name
angular.module('dash.map.MeasurementLayerEditor', [])

//Angular stuff
.controller('MeasurementLayerEditorController', require('./MeasurementLayerEditorController'))
.directive('measurementLayerEditor', require('./MeasurementLayerEditorDirective'));



// WEBPACK FOOTER //
// ./src/app/dash/map/measurementLayerEditor/index.js